export enum RelationConnection {
  And = 'AND',
  Or = 'OR',
}
